// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"5424840f","334":"8d166439","442":"fba80c17","621":"1c74a031","727":"8b785d02","740":"8b78e9f9","952":"18c6fabc"}[chunkId] + ".chunk.js";
};